import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { PermissionModel } from './models/permission-model';
import { PermissionModelImpl } from './models/impls/permission-model';
import { PermissionService } from './services/permission-service';
import { PermissionServiceImpl } from './services/impls/permission-service';

export const permissionModule = (bind: interfaces.Bind) => {
    bind(PermissionModel).to(PermissionModelImpl);
    bind(PermissionService).to(PermissionServiceImpl);
};
